<template>
  <fa-icon icon="comments" fixed-width />
</template>
